import { render, staticRenderFns } from "./appleButton.vue?vue&type=template&id=530225e2&"
import script from "./appleButton.vue?vue&type=script&lang=js&"
export * from "./appleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports